// import { ContentLayout } from '@connected/ui/layouts/content/layout';
import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/(auth)/projects/$projectVersionId/applications')({
    component: Layout,
});

function Layout() {
    return <Outlet />;
    // return (
    //     <ContentLayout className="w-full">
    //         <ContentLayout.Outlet />
    //     </ContentLayout>
    // );
}
